var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hadMonitor)?_c('div',[_c('dashboard-cards',{ref:"dashboardCards",attrs:{"useLocalPanels":"","extraParams":_vm.extraParams,"localPanels":_vm.localPanels}})],1):_c('a-alert',{attrs:{"message":_vm.$t('db.text_183'),"description":_vm.$t('db.text_184'),"type":"warning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }